import { FC, ReactElement } from 'react'
import {
    Navigate,
    Route,
    Routes,
    useLocation,
} from 'react-router'

import { trans } from '@/helpers/trans'
import { DocumentsPage, InactiveUserPage, LoketHoursPerPeriodPage } from '@/pages'

import { InactiveUserTopBar } from './subcomponents'

export const InactiveUserRouteGroup: FC = (): ReactElement => {
    const location = useLocation()

    return (
        <div className="inactive-user-route-group">
            <InactiveUserTopBar showBackButton={location.pathname !== '/'} />

            <Routes>
                <Route
                    path={`/${trans('nav.documents.link')}`}
                    element={<DocumentsPage />}
                />

                <Route
                    path={`/${trans('nav.absences.link')}/${trans('nav.absences.loketHoursPerPeriod.link')}`}
                    element={<LoketHoursPerPeriodPage />}
                />

                <Route
                    path="/"
                    element={<InactiveUserPage />}
                />

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    )
}
